import React from 'react';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/modal';
import Typography from '../../Typography';
import theme from '../../../../theme';
import Button from '../../Button';
import { SubsctiptionType } from '../../../../../types/common';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../../../store/reducer-main';
import { toast } from 'react-toastify';
import { upgradeDowngradeSubscription } from '../../../../../service/common/stripe';
import { MembershipType } from '../../../../../enums/profile';
import ReducedProductCard from '../../ReducedProductCard';
import { getPlanRecurringPeriod } from '../../../../../helpers/stripeUtils';
import { ProductWithPrice } from '../../../../../types/stripe';

interface Props{
  subscriptionType:SubsctiptionType
  setSubscriptionTypeHandler:(props:SubsctiptionType)=>void
}

export default function ModifyPlanModalContent({subscriptionType,setSubscriptionTypeHandler}:Props) {
  
  const {products,loadingProducts} = useSelector((state: StoreState) => state.stripe);  
  const { userProfile } = useSelector((state: StoreState) => state.profile);
  
  const [loading, setLoading] = React.useState<boolean>(false);
  const [selectedProd, setSelectedProd] = React.useState<ProductWithPrice | null>(null);
  
  React.useEffect(() => {
    if (products.length > 0) {
      setSelectedProd(products[0]);
    } else {
      setSelectedProd(null);
    }
  }, [products]);

  const currentProd = React.useMemo(() => {
    if (!userProfile?.membership) return null;
    if (userProfile.membership.type === MembershipType.TRIAL) return null;
    const subItems = userProfile.membership.subscriptionData.items?.data;
    if (!subItems || !(subItems instanceof Array)) return null;
    const subProd = subItems[0];
    if (!subProd) return null;
    return subProd.price?.product ?? null;
  }, [userProfile]);

  console.log('current SUB PROD', currentProd);

  const onSubscriptionUpdatePress = async () => {
    try {
      if (!selectedProd) return;
      if (!userProfile || !userProfile.membership) return;
      const membership = userProfile.membership;
      if (membership.type === MembershipType.TRIAL) return;
      const currentSubId: string = membership.subscriptionData.id;
      if (!currentSubId) {
        throw 'Invalid subscription';
      }
      setLoading(true);
      const newPriceId = selectedProd.default_price.id;
      console.log('INIZO');
      await upgradeDowngradeSubscription(newPriceId, currentSubId);
      console.log('FINE: OK');
      toast.success('Il piano è stato modificato con successo');
      setTimeout(() => {
        window.location.reload();
        setLoading(false);
      }, 1500)
    } catch (error) {
      console.log('err', error);
      toast.error('Si è verificato un errore durante la modifica del piano di abbonamento');
      setLoading(false);
    }
  }
      
    return (
      <div className='my-4'>
        <Typography style={{textAlign:"center"}} variant="display">Modifica Abbonamento</Typography>
        <div className='flex flex-col justify-center my-4 gap-4'>
          {products.map((prod)=>{
            if (prod.id !== currentProd) return (
              <ReducedProductCard 
                reduced
                key={prod.id}
                productName={prod.name}
                onPress={() => setSelectedProd(prod)}
                productDescription={prod.description}
                recurringPeriod={getPlanRecurringPeriod(prod.default_price)}
                price={`${((prod.default_price.unit_amount ?? 0) / 100).toFixed(2).replace('.', ',')} €`}
                selected={prod.id === selectedProd?.id}
                />
            )
          })}
          <Button className='mt-8' onClick={onSubscriptionUpdatePress} colorVariant="primary" title='AGGIORNA' variant="primary" loading={loading} disabled={loading}/>
          <Typography className='mt-5' colorVariant="textLabel" variant="label">L'aggiornamento al nuovo abbonamento sarà effettivo al termine dell'abbonamento attuale.</Typography>        
        </div>
      </div>  
    );
 }
